import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .TagAutomationField {
    width: 100%;
    border-top: 1px solid #b8b8b8;
    margin-top: 10px;
    padding-top: 15px;
  }

  .TagAutomationField__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .TagAutomationField__label {
    font-size: 14px;
    font-weight: 500;
    color: #000;
  }

  .TagAutomationField__content {
    margin-top: 15px;
    padding: 15px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #fff;
  }

  .TagAutomationField__subtitle {
    font-size: 14px;
    font-weight: 500;
    color: #000;
    margin-bottom: 8px;
  }

  .TagAutomationField__rule-text {
    font-size: 13px;
    color: #6b6b6b;
    margin: 0 0 12px;
    line-height: 1.5;
  }

  .TagAutomationField__preview {
    margin-top: 12px;
    padding: 10px 12px;
    background: #f0f7ff;
    border: 1px solid #d0e3ff;
    border-radius: 4px;
    font-size: 13px;
    color: #4a4a4a;
    line-height: 1.5;
  }

  .TagAutomationField__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .TagAutomationField__confirm {
    width: 420px;
    max-width: calc(100% - 30px);
    background: #fff;
    border-radius: 6px;
    padding: 24px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }

  .TagAutomationField__confirm-title {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-bottom: 12px;
  }

  .TagAutomationField__confirm-text {
    font-size: 14px;
    color: #4a4a4a;
    line-height: 1.5;
    margin: 0 0 20px;
  }

  .TagAutomationField__confirm-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .TagAutomationField__confirm-remove,
  .TagAutomationField__confirm-cancel {
    padding: 8px 18px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
    border: 1px solid transparent;
  }

  .TagAutomationField__confirm-remove {
    background: #d9534f;
    color: #fff;
    &:hover {
      background: #c9302c;
    }
  }

  .TagAutomationField__confirm-cancel {
    background: #fff;
    border-color: #d9d9d9;
    color: #4a4a4a;
    &:hover {
      border-color: #b3b3b3;
    }
  }
`;

export { staticStyles };
